import { Box, Chip, SxProps, Theme, Typography } from "@mui/material";
import FormStatusIcon, { FormStatus } from "../forms/formStatusIcon";

export default function ConsentFormHeader({
  name,
  signedAt,
  textSx = {},
  isOptOut,
}: {
  name: string;
  signedAt: string;
  textSx?: SxProps<Theme>;
  isOptOut: boolean;
}) {
  const formStatus = signedAt ? FormStatus.SUBMITTED : FormStatus.INCOMPLETE;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        pr: 1,
      }}
    >
      <FormStatusIcon status={formStatus} />
      <Typography
        noWrap
        sx={{
          color: "text.primary",
          ml: 1,
          ...textSx,
        }}
      >
        {name}
      </Typography>
      {signedAt && isOptOut && <Chip label="Opted out" sx={{ ml: 1 }} />}
    </Box>
  );
}
